interface ComputerWithChessPieceSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerWithChessPieceSVG = ({
  color,
  style,
}: ComputerWithChessPieceSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="50"
    viewBox="0 0 41 50"
    fill="none"
  >
    <g clipPath="url(#clip0_768_10650)">
      <path
        d="M26.7242 15.8958H37.0949C38.7928 15.8958 40.1694 17.2724 40.1694 18.9703V41.116C40.1694 42.8139 38.7928 44.1905 37.0949 44.1905H3.58722C1.88935 44.1905 0.512695 42.8139 0.512695 41.116V18.9703C0.512695 17.2724 1.88935 15.8958 3.58722 15.8958H13.9488"
        stroke={color}
        strokeWidth="1.0279"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.86328 37.8671H36.8203"
        stroke={color}
        strokeWidth="1.0279"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1975 41.0334C16.1975 41.2261 16.0415 41.3822 15.8488 41.3822C15.656 41.3822 15.5 41.2261 15.5 41.0334C15.5 40.8407 15.656 40.6847 15.8488 40.6847C16.0415 40.6847 16.1975 40.8407 16.1975 41.0334Z"
        stroke={color}
        strokeWidth="1.0279"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.6858 41.0334C20.6858 41.2261 20.5298 41.3822 20.337 41.3822C20.1443 41.3822 19.9883 41.2261 19.9883 41.0334C19.9883 40.8407 20.1443 40.6847 20.337 40.6847C20.5298 40.6847 20.6858 40.8407 20.6858 41.0334Z"
        stroke={color}
        strokeWidth="1.0279"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.1829 41.0334C25.1829 41.2261 25.0268 41.3822 24.8341 41.3822C24.6414 41.3822 24.4854 41.2261 24.4854 41.0334C24.4854 40.8407 24.6414 40.6847 24.8341 40.6847C25.0268 40.6847 25.1829 40.8407 25.1829 41.0334Z"
        stroke={color}
        strokeWidth="1.0279"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6926 44.1997L11.3068 48.2838C11.114 48.862 11.4536 49.4952 11.9492 49.4952H28.7168C29.2124 49.4952 29.552 48.862 29.3593 48.2838L27.9734 44.1997"
        stroke={color}
        strokeWidth="1.0279"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.3664 25.2111H30.6707V27.9093L35.8837 23.4948L30.6707 19.0804V21.7786H24.6318"
        stroke={color}
        strokeWidth="1.0279"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.2018 31.1031C26.5964 30.0752 26.3578 28.9097 25.5961 28.1204L25.1739 27.6799C23.0263 25.4589 21.9801 22.3017 22.5858 19.1171C22.6868 18.5664 23.1181 18.1443 23.6504 18.0433C24.3479 18.0433 24.6783 17.6211 24.6783 17.1439V16.786C24.6783 16.2904 24.2745 15.8865 23.7789 15.8865C23.0172 15.8865 22.7051 15.96 22.6042 15.6204C22.4848 15.2349 22.5674 14.7761 22.7235 14.5191L23.7422 11.417C23.9166 10.8755 23.9349 10.3157 23.8064 9.78339C23.6688 9.24191 23.3659 8.76467 22.9621 8.37921L20.3281 5.85535L17.6941 8.37921C17.2903 8.76467 16.9874 9.24191 16.8498 9.78339C16.7213 10.3157 16.7304 10.8847 16.914 11.417C18.1622 15.2258 18.208 15.1064 18.052 15.6112C17.997 15.7856 17.8501 15.8774 17.6757 15.8774H17.0149C16.5194 15.8774 16.1155 16.2812 16.1155 16.7768V17.1347C16.1155 17.6303 16.5194 18.0341 17.0149 18.0341C17.5656 18.1443 17.9878 18.5297 18.1163 19.3098C18.6394 22.3476 17.639 25.4497 15.4915 27.6707C15.2069 27.9644 13.7385 29.2034 14.4544 31.094"
        stroke={color}
        strokeWidth="1.0279"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.2107 33.9666V32.2228C27.2107 31.7273 26.816 31.3326 26.3204 31.3326H14.3619C13.8663 31.3326 13.4717 31.7273 13.4717 32.2228V33.9666H27.2198H27.2107Z"
        stroke={color}
        strokeWidth="1.0279"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.3369 5.85536V0.513947"
        stroke={color}
        strokeWidth="1.0279"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1895 3.00107H22.4754"
        stroke={color}
        strokeWidth="1.0279"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_768_10650">
        <rect width="40.6755" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ComputerWithChessPieceSVG;
